import { User } from "../@core/data/users";

export default class Exercise {
  id?: string;
  courseId?: string;
  sectionId?: string;
  lectureId?: string;
  refTitle?: string;

  title?: string;
  description?: string;
  tags?: string[];
  coverUrl?: string;
  privacy?: boolean;
  status?: number;
  showComments?: boolean;
  newComment?: boolean;

  messageCompleted?: string;
  percentCompleted?: number;
  duration?: number; //minute
  isRepeated?: boolean;
  startDate?: Date;
  endDate?: Date;
  noQuiz?: number;
  exQuizzes?: ExerciseQuiz[];

  noExUser?: number;
  noExUserCompleted?: number;
  exerciseUsers?: ExerciseUser[];

  noViewer?: number;
  noLiked?: number;
  noComment?: number;

  //render / process ui
  noQuizValue?: number;

  //Moderator
  isReviewed?: boolean;
  isApproved?: boolean;
  approvedOn?: Date;
  approvedBy?: string;
  approvedAuthor?: User;

  timestamp?: number;
  author?: User;
  createdBy?: string;
  createdOn?: Date;
  updatedBy?: string;
  updatedOn?: Date;
  isDeleted?: boolean;
  isActive?: boolean;
  visibility?: string;
  accessToken?: string;
}

export class ExerciseQuiz {
  id?: string;
  exerciseId?: string;
  quizId?: string;
  quizTitle?: string;
}

export class ExerciseUser {
  id?: string;
  exerciseId?: string;
  percentCompleted?: number;
  duration?: number; //minute
  isRepeated?: boolean;
  startDate?: Date;
  endDate?: Date;
  exQuizzes?: ExerciseQuiz[];
  totalQuiz?: number;

  noAttempt?: number;
  noQuiz?: number;
  noCorrect?: number;
  noIncorrect?: number;
  timeSpent?: number;
  lastQuizId?: string;

  finishedOn?: Date;
  finished?: boolean;

  progress?: number;
  percentage?: number;
  isHighest?: boolean;

  enrollmentId?: string;

  timestamp?: number;
  author?: User;
  createdBy?: string;
  createdOn?: Date;
  updatedBy?: string;
  updatedOn?: Date;
  isDeleted?: boolean;
  isActive?: boolean;
  visibility?: string;
  accessToken?: string;
}
